import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";

import './Faq.scss'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    Footer
} from '../../components/_index';
import { Box } from '@material-ui/core';
import { withTranslation } from 'react-i18next';

export default withTranslation()(function Faq({t}) {
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-015'}</title>
            </Helmet>
            <div className="wrapper FAQ">
                <Header langLock="langLocked" />
                <div className="mainWrapper">
                    <div className="contentWrapper">
                        <FormBox header={t("terms.faq.title")}>
                            <Box
                                p={5}
                                bgcolor="tnc.main"
                            >
                                <a href="http://www.gov.hk/en/about/helpdesk/faq/infosec/index.htm" target="_blank" rel="noreferrer">{t("terms.faq.informationSecurity")}</a>
                                <br/>
                                <a href="http://www.gov.hk/en/about/helpdesk/faq/other/index.htm" target="_blank" rel="noreferrer">{t("terms.faq.troubleShoot")}</a>
                            </Box>
                        </FormBox>
                    </div>
                </div>
            </div>
            <Footer />
        </main>
    )
})
